{
  "appName": "نظام صرف العملات",
  "platform": "المنصة",
  "actions": {
    "save": "حفظ",
    "cancel": "إلغاء",
    "delete": "حذف",
    "edit": "تعديل",
    "create": "إضافة",
    "search": "بحث",
    "retry": "إعادة المحاولة",
    "close": "إغلاق",
    "confirm": "تأكيد",
    "apply": "تطبيق",
    "view": "عرض",
    "rotate": "تدوير",
    "reset": "إعادة تعيين",
    "addItem": "إضافة عنصر",
    "expandAll": "توسيع الكل",
    "collapseAll": "طي الكل"
  },
  "yes": "نعم",
  "no": "لا",
  "nav": {
    "dashboard": "لوحة التحكم",
    "users": "المستخدمون",
    "settings": "الإعدادات",
    "logout": "تسجيل الخروج",
    "toggleSidebar": "تبديل الشريط الجانبي"
  },
  "language": {
    "label": "اللغة",
    "ar": "العربية",
    "en": "English",
    "switchTo": {
      "ar": "التبديل إلى العربية",
      "en": "Switch to English"
    }
  },
  "theme": {
    "switchToLight": "التبديل إلى الوضع الفاتح",
    "switchToDark": "التبديل إلى الوضع الداكن"
  },
  "preferences": {
    "label": "إعدادات اللغة والمظهر"
  },
  "state": {
    "loading": "جاري التحميل...",
    "empty": "لا توجد بيانات",
    "error": "تعذر تحميل البيانات. أعد المحاولة."
  },
  "accessDenied": {
    "title": "لا تملك صلاحية الوصول",
    "description": "تواصل مع المسؤول إذا كنت بحاجة إلى هذه الصلاحية."
  },
  "pagination": {
    "page": "صفحة {{page}} من {{totalPages}}",
    "total": "{{total}} سجل",
    "next": "التالي",
    "previous": "السابق",
    "label": "التنقل بين الصفحات",
    "goToPrevious": "الذهاب إلى الصفحة السابقة",
    "goToNext": "الذهاب إلى الصفحة التالية",
    "morePages": "صفحات أخرى"
  },
  "drawer": {
    "discardTitle": "تجاهل التغييرات؟",
    "discardDescription": "لن يتم حفظ البيانات المدخلة في هذا النموذج. لا يمكن التراجع عن هذا الإجراء.",
    "discardConfirm": "تجاهل التغييرات",
    "discardCancel": "متابعة التعديل"
  },
  "search": {
    "noResults": "لا نتائج مطابقة للبحث"
  },
  "selectItem": {
    "placeholder": "اختر عنصرا...",
    "selected": "عنصر محدد"
  },
  "multiselect": {
    "selectSomeItems": "اختر عناصر"
  },
  "media": {
    "imageViewer": "عارض الصور",
    "viewLarger": "عرض بحجم أكبر",
    "editImage": "تعديل الصورة",
    "cropAndAdjust": "قص الصورة وضبطها",
    "zoom": "التكبير",
    "zoomIn": "تكبير",
    "zoomOut": "تصغير",
    "rotation": "التدوير",
    "cameraCapture": "التقاط بالكاميرا",
    "positionInFrame": "ضع نفسك داخل الإطار",
    "takePhoto": "التقاط صورة",
    "uploadFile": "رفع ملف",
    "uploaded": "تم الرفع",
    "dragDropImage": "اسحب صورة وأفلتها هنا",
    "selectedLabel": "المحدد",
    "deleteTitle": "حذف {{name}}؟",
    "deleteMessage": "ستتم إزالة {{name}}. لا يمكن التراجع عن هذا الإجراء."
  },
  "treeDemo": {
    "title": "مستعرض الملفات",
    "searchPlaceholder": "البحث في الملفات",
    "reports": "التقارير",
    "salesReport": "تقرير المبيعات",
    "inventoryReport": "تقرير المخزون",
    "documents": "المستندات",
    "invoiceTemplate": "نموذج فاتورة",
    "configurations": "الإعدادات"
  },
  "table": {
    "pageSizeLabel": "عدد الصفوف بالصفحة",
    "actionsColumn": "الإجراءات",
    "rowActionsLabel": "إجراءات {{name}}"
  },
  "status": {
    "active": "نشط",
    "inactive": "غير نشط",
    "deleted": "مؤرشف",
    "pending": "قيد الانتظار",
    "closed": "مغلق",
    "safe": "آمن",
    "cancelled": "ملغى",
    "posted": "مسجل"
  },
  "combobox": {
    "placeholder": "اختر...",
    "search": "بحث...",
    "empty": "لا توجد نتائج",
    "clearOption": "بدون",
    "clearSelection": "مسح التحديد",
    "removeSelection": "إزالة {{label}}",
    "selectedCount_one": "تم اختيار {{count}} عنصر",
    "selectedCount_two": "تم اختيار {{count}} عنصر",
    "selectedCount_few": "تم اختيار {{count}} عناصر",
    "selectedCount_many": "تم اختيار {{count}} عنصر",
    "selectedCount_other": "تم اختيار {{count}} عنصر",
    "options": "الخيارات",
    "searchOptions": "بحث في الخيارات"
  },
  "filterToolbar": {
    "phoneCountryCode": "رمز الدولة",
    "toggle": "الفلاتر",
    "resetFilters": "إعادة تعيين الفلاتر"
  },
  "sidebar": {
    "title": "القائمة الجانبية",
    "description": "التنقل بين صفحات النظام"
  },
  "toaster": {
    "label": "الإشعارات"
  },
  "breadcrumb": {
    "label": "مسار التنقل",
    "more": "المزيد"
  },
  "selection": {
    "selectRow": "تحديد الصف"
  }
}
